import { render, staticRenderFns } from "./payPassword.vue?vue&type=template&id=dd7b3324&scoped=true&"
import script from "./payPassword.vue?vue&type=script&lang=js&"
export * from "./payPassword.vue?vue&type=script&lang=js&"
import style0 from "./payPassword.vue?vue&type=style&index=0&id=dd7b3324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7b3324",
  null
  
)

export default component.exports